import { Component, OnInit, Input, Output, EventEmitter, ElementRef, forwardRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { TranslationSettings } from '../language-translation/translation-settings';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { LabelDTO } from 'dev-corize-api-client';
import { CorizeBaseComponent } from '../../models/base-corize-component';
import { ToastService } from '../../services/toastr-service';
import { Guid } from 'guid-typescript';
import { LanguageTranslationComponent } from '../language-translation/language-translation.component';
import { CorizeEnvironment } from '../../models/corize-environment';
import { AfterViewInit } from '@angular/core';


@Component({
  selector: 'app-translate',
  templateUrl: './translate.component.html',
  styleUrls: ['./translate.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TranslateComponent),
      multi: true
    }
  ]
})
export class TranslateComponent extends CorizeBaseComponent implements AfterViewInit, OnInit, ControlValueAccessor {

  translated: FormGroup;
  theValue: any;
  isDisabled: boolean;
  public form: FormGroup;
  @Input() translationId: string;
  @Input() label: string = '';
  @Output() textChanged: EventEmitter<LabelDTO> = new EventEmitter<LabelDTO>();
  @ViewChild('theInput') input: ElementRef;

  constructor(public dialog: MatDialog, protected toast: ToastService, protected corize: CorizeEnvironment) {
    super();
  }
  onChange: any = () => { }
  onTouch: any = () => { }


  registerOnChange(fn: any) {
    this.onChange = fn
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn
  }


  onInput(value: string) {
    var d: LabelDTO = {
      id: this.translationId,
      textInCurrentLanguage: value
    }

    this.value = d;
    this.theValue = d;
  }

  ngOnDestroy() {

  }

  @Input()
  get required() {
    return this._required;
  }
  set required(req) {
    this._required = coerceBooleanProperty(req);

  }
  private _required = false;

  setDescribedByIds(): void {
    throw new Error('Method not implemented.');
  }
  onContainerClick(): void {
    throw new Error('Method not implemented.');
  }

  get value(): any | null {

    return this.theValue;
  }

  set value(val: any | null) {

    if (typeof val === 'object' && 'textInCurrentLanguage' in val) {
      this.theValue = val;
      this.onChange(val)
      this.onTouch(val)
    }
  }

  writeValue(value: any): void {
    if (typeof value === 'object' && 'textInCurrentLanguage' in value) {

      this.value = value || '';
      this.theValue = value || '';
      this.onChange(value)
      this.onTouch(value)
    }
    else {
      this.toast.showError("Invalid translation type")
    }
  }



  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
  ngOnInit(): void {

    if (this.translationId == undefined) {
      this.translationId = Guid.EMPTY;
    }
  }

  ngAfterViewInit() {
    this.translationId = this.value.id;
    this.value = this.value.textInCurrentLanguage;
  }


  showTranslate() {
    var t = this;
    var data = new TranslationSettings(this.translationId);

    data.defaultLanguage = this.corize.customerData.defaultLanguage.code;
    data.languages = this.corize.customerData.languages;

    t.dialog.open(LanguageTranslationComponent, {
      data: [data, this.input.nativeElement.value]
    })
      .afterClosed()
      .subscribe((ret: LabelDTO) => {

        if (ret != undefined && ret != "") {
          this.translationId = ret.id;
          this.writeValue(ret);
          this.textChanged.emit(ret);
        }
      });
  }
}
